// 業務管理の横断状態: 選択中の担当者（localStorage に保持）とトースト。
import { defineStore } from "pinia";
import { computed, ref } from "vue";

const STAFF_KEY = "bizhub.staffId";

// localStorage は Safari のプライベートモード等で例外を投げるので、読み書きは必ずここを通す
function readStaffId() {
  try {
    return Number(localStorage.getItem(STAFF_KEY)) || null;
  } catch {
    return null;
  }
}

function writeStaffId(id) {
  try {
    if (id) localStorage.setItem(STAFF_KEY, String(id));
    else localStorage.removeItem(STAFF_KEY);
  } catch {
    // 保存できなくても選択はこのタブの間だけ有効
  }
}

export const useBizhubStore = defineStore("bizhub", () => {
  const staffList = ref([]);
  const staffId = ref(readStaffId());
  const staffDialog = ref(false);
  const snack = ref({ show: false, message: "", color: "success" });

  const currentStaff = computed(() => staffList.value.find((s) => s.id === staffId.value) || null);

  async function loadStaff() {
    // 循環 import を避けるため動的 import
    const { listStaff } = await import("@/api/bizhubApi");
    staffList.value = (await listStaff()) || [];
    if (staffId.value && !staffList.value.some((s) => s.id === staffId.value)) {
      selectStaff(null);
    }
  }

  function selectStaff(id) {
    staffId.value = id;
    writeStaffId(id);
  }

  // 書き込み操作の前に呼ぶ。未選択ならセレクタを開いて false。
  function requireStaff() {
    if (staffId.value) return true;
    staffDialog.value = true;
    return false;
  }

  function toast(message, color = "success") {
    snack.value = { show: true, message, color };
  }

  return { staffList, staffId, currentStaff, staffDialog, snack, loadStaff, selectStaff, requireStaff, toast };
});
